import { Card, CardContent, CardHeader, CardTitle } from "@/ui-components/ui/card";
import { Kpi } from "../interfaces";

export function KpiCards({ kpis }: { kpis: Kpi[] }) {
  return (
    <div className="grid gap-4 md:grid-cols-2 xl:grid-cols-4">
      {kpis.map((kpi) => (
        <Card
          key={kpi.title}
          className="relative overflow-hidden border shadow-sm bg-white"
        >
          {/* Subtle iOS-like light metal gradient */}
          <div className="absolute inset-0 bg-gradient-to-br from-white via-slate-50 to-slate-100 opacity-80" />
          {/* Soft highlight */}
          <div className="absolute -right-12 -bottom-12 h-40 w-40 rounded-full bg-white/40 blur-3xl" />
          <CardHeader className="flex flex-row items-center justify-between pb-2 relative z-10">
            <CardTitle className="text-sm font-medium tracking-wide text-slate-700">
              {kpi.title}
            </CardTitle>
            <kpi.icon className="h-5 w-5 text-slate-400" />
          </CardHeader>
          <CardContent className="relative z-10 text-slate-900">
            <div className="text-3xl font-semibold tracking-tight">{kpi.value}</div>
            <p className="text-xs mt-1 text-slate-500">{kpi.change}</p>
          </CardContent>
        </Card>
      ))}
    </div>
  );
}
